import { all, select, call, fork, put, takeLatest, takeEvery, delay } from "redux-saga/effects";
import { API } from "aws-amplify";
import { ExceptionMap } from "antd/lib/result";
import { upperFirst } from "../../helpers/Utils";

import {
  SERVICE_GET_LIST,
  SERVICE_GET_LIST_SUCCESS,
  SERVICE_GET_LIST_ERROR,
  SERVICE_GET_LIST_WITH_FILTER,
  SERVICE_GET_LIST_WITH_ORDER
} from "../actions";

import { getServiceListSuccess, getServiceListError } from "./actions";

const SERVICES_BASE = "/hotels/services";

export const addSoftFields = (item, locale = "en", timeZone = "Europe/Istanbul") => {
  const toReturn = item;

  if (!timeZone || timeZone === undefined) {
    timeZone = "Europe/Istanbul";
  }

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h24",
    hour12: false,
    timeZone
  };
  const optionsWithSecond = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h24",
    hour12: false,
    timeZone
  };

  if (toReturn.updated_at) {
    toReturn.updated_at_date = new Date(toReturn.updated_at * 1000).toLocaleDateString(locale, optionsWithSecond);
  }
  if (toReturn.created_at) {
    toReturn.created_at_date = new Date(toReturn.created_at * 1000).toLocaleDateString(locale, options);
  }

  const { user } = item;
  if (user) {
    toReturn.fullName = `${upperFirst(user.name)} ${upperFirst(user.family_name)}`;
  } else if (item.name && item.family_name) {
    toReturn.fullName = `${upperFirst(item.name)} ${upperFirst(item.family_name)}`;
  }
  // delete toReturn.user;

  return toReturn;
};

export const mapServiceResult = (bookings, locale, timeZone) => {
  if (bookings instanceof Array) {
    return bookings.map(item => {
      return addSoftFields(item, locale, timeZone);
    });
  }
  if (bookings instanceof Object) {
    return addSoftFields(bookings, locale, timeZone);
  }

  console.error("Coud not add soft constraints due to strange typed result");
  throw new Error("Coud not add soft constraints due to strange typed result");
};

export const getServiceListAsync = async (api = API, hotelId, timeZone, locale) => {
  const apiName = "WebeeAPI";
  const path = SERVICES_BASE;
  let myInit = {
    queryStringParameters: {
      hotel_id: hotelId
    }
  };

  myInit = {
    queryStringParameters: {
      hotel_id: hotelId
    }
  };

  try {
    const result = await api.get(apiName, path, myInit);
    return mapServiceResult(result, locale, timeZone);
  } catch (err) {
    throw err;
  }
};

export function* getServiceListItems({ payload }, api = API) {
  try {
    yield delay(500);
    const state = yield select();
    const { hotelId } = state.settings.hotelConfig;
    const { timeZone } = state.settings.hotelConfig;
    const response = yield call(getServiceListAsync, api, hotelId, timeZone);
    yield put(getServiceListSuccess(response));
  } catch (error) {
    yield put(getServiceListError(error));
  }
}

export function* watchGetList() {
  yield takeLatest(SERVICE_GET_LIST, getServiceListItems);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}
